import React from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash-es/isEmpty';
import cn from 'src/classnames';
import Button from '@mui/material/Button';
import useTracking from 'components/Globals/Analytics';
import { useTrackingClickStyles } from 'components/Globals/TrackingTester/TrackingTester';
import styles from './TextButton.module.scss';

const TextButton = ({
  children,
  className,
  onClick,
  startIcon,
  endIcon,
  textView,
  disabled,
  classes,
  trackingData = {},
  skipTracking = false,
}) => {
  const track = useTracking();
  const trackingClasses = useTrackingClickStyles(trackingData, skipTracking);

  const handleClick = e => {
    if (onClick) {
      onClick(e);
    }

    if (!_isEmpty(trackingData)) {
      track.click(trackingData);
    }
  };

  return (
    <Button
      className={cn(styles.button, className, { [styles.regularText]: startIcon || textView }, trackingClasses)}
      onClick={handleClick}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      classes={{ ...classes, startIcon: styles.startIcon }}
    >
      {children}
    </Button>
  );
};

TextButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func,
  startIcon: PropTypes.oneOfType([PropTypes.element, PropTypes.number]),
  endIcon: PropTypes.element,
  textView: PropTypes.bool,
  disabled: PropTypes.bool,
  classes: PropTypes.object,
};

TextButton.defaultProps = {
  className: '',
  startIcon: null,
  endIcon: null,
  textView: false,
  disabled: false,
  onClick: () => {},
  classes: {},
};

export default TextButton;
